<ng-container *ngIf="license$ | async as license">
  <!-- Overlay de fondo -->
  <div *ngIf="isDialogVisible" class="dialog-overlay">
    <!-- Contenedor del dialog -->
    <div class="dialog-container">
      <!-- Header con icono de peligro -->
      <div class="dialog-header">
        <div class="header-content">
          <div class="danger-icon">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <h2 class="dialog-title">¡Atención: Suscripción en riesgo!</h2>
          <div class="warning-badge">URGENTE</div>
        </div>
      </div>

      <!-- Contenido principal -->
      <div class="dialog-content">
        <div class="alert-message">
          <h3 class="main-warning">Su plan está próximo a finalizar</h3>
          <p class="expiry-details">
            El acceso a la plataforma de monitoreo será
            <strong class="highlight-danger">suspendido</strong>
            una vez que finalice su suscripción.
          </p>
        </div>

        <!-- Lista de consecuencias -->
        <!-- <div class="consequences-list">
          <h4 class="consequences-title">
            Esto implica la pérdida de acceso a:
          </h4>
          <ul class="blocked-features">
            <li>
              <i class="pi pi-times-circle"></i>
              <span>Monitoreo en tiempo real</span>
            </li>
            <li>
              <i class="pi pi-times-circle"></i>
              <span>Reportes e historial de rutas</span>
            </li>
            <li>
              <i class="pi pi-times-circle"></i>
              <span>Alertas y notificaciones</span>
            </li>
            <li>
              <i class="pi pi-times-circle"></i>
              <span>Gestión de geocercas y conductores</span>
            </li>
          </ul>
        </div> -->

        <!-- Información de tiempo restante -->
        <div class="time-remaining">
          <div class="countdown-container">
            <div class="countdown-text">
              <span class="time-label">Tiempo restante:</span>
              <span class="time-value">
                <span class="time-number">{{
                  (license.remainingTime | secondsToTimeDetailed).value
                }}</span>
                <span class="time-unit">{{
                  (license.remainingTime | secondsToTimeDetailed).unit
                }}</span>
              </span>
            </div>
          </div>
        </div>

        <!-- Mensaje de acción requerida -->
        <div class="action-required">
          <div class="urgent-notice">
            <i class="pi pi-info-circle"></i>
            <span>
              Comuníquese de inmediato con nuestro equipo al 978726211.
            </span>
          </div>
        </div>
      </div>

      <!-- Footer con botones de acción -->
      <div class="dialog-footer">
        <a
          class="btn btn-contact"
          href="https://api.whatsapp.com/send?phone=51978726211&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20GLtracker"
          target="_blank"
        >
          <i class="pi pi-phone"></i>
          Contactar soporte
        </a>
        <button
          (click)="closeDialog()"
          class="btn btn-acknowledge"
          type="button"
        >
          <i class="pi pi-check"></i>
          Entendido
        </button>
      </div>

      <!-- Botón de cerrar -->
      <button (click)="closeDialog()" class="dialog-close" type="button">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</ng-container>
